import {
  Button,
  Col,
  DatePicker,
  Drawer,
  Form,
  Input,
  Row,
  Select,
  Switch,
  message,
} from "antd";
import CalendarCustom from "../Calendar/CalendarCustom";
import "react-calendar/dist/Calendar.css";
import locale from "antd/es/date-picker/locale/vi_VN";
import {
  calculateTimeDifference,
  formatNumberWithDots,
} from "../../helpers/utils"; // Import locale cho DatePicker
import dayjs from "dayjs";
import "moment/locale/vi"; // Import locale tiếng Việt
import React, { useEffect, useMemo, useState } from "react";
import BgForm from "../../images/bg-form-2.png";
import $axios from "../../services/axios";
import CustomInputNumber from "../Common/CustomInputNumber";
import TicketDetailsDrawer from "../Common/DetailTicket";
import { dateFilterAir } from "../../helpers/formatDate";

const Step1 = ({
  form,
  onChangeStep,
  tripType,
  setTripType,
  setAirport,
  airports,
  loadingAirPorts,
  setFilterDay,
  setFilterDayReturn,
}) => {
  const listAirPortVn = ["HAN", "SGN", "DAD", "CXR", "HPH", "PQC"];
  const listAirPortGlobal = [
    "DA",
    "DB",
    "AS",
    "TQ",
    "EU",
    "SA",
    "NA",
    "AF",
    "OC",
  ];
  const StartPoint = Form.useWatch("StartPoint", form);
  const EndPoint = Form.useWatch("EndPoint", form);

  const [valueCalendar, setValueCalendar] = useState(new Date());
  const [airportsDom, setAirportsDom] = useState([]);
  const [airportsFor, setAirportsFor] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [nameField, setNameField] = useState("StartPoint");
  const [cheapFlights, setcheapFlights] = useState([]);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [detailTicket, setDetailTicket] = useState({});
  const [openCalendar, setOpenCalendar] = useState(false);
  const [typeCalendar, setTypeCalendar] = useState("");
  const [minDateCalendar, setMinDateCalendar] = useState(new Date());

  // Hàm xử lý chọn sân bay
  const handleSelect = (value) => {
    form.setFieldValue(nameField, value);
    setOpenDrawer(false); // Đóng drawer sau khi chọn
  };

  const removeDiacritics = (str) => {
    if (!str) return ""; // Xử lý trường hợp chuỗi null hoặc undefined
    return str
      .normalize("NFD") // Phân tách ký tự có dấu
      .replace(/[\u0300-\u036f]/g, "") // Loại bỏ dấu
      .replace(/đ/g, "d") // Thay thế "đ" thành "d"
      .replace(/Đ/g, "D"); // Thay thế "Đ" thành "D"
  };

  // Lọc sân bay theo từ khóa tìm kiếm
  const filterAirports = useMemo(() => {
    if (airportsDom.length) {
      const arr = [];

      const airPortFilter = airportsDom.filter((item) =>
        removeDiacritics(
          `${item.name_vi} ${item?.city_name_vi} ${item.city_code} ${item.country_name_en}`
        )
          .toLowerCase()
          .includes(removeDiacritics(searchTerm).toLowerCase())
      );

      listAirPortVn.forEach((code) => {
        const index = airPortFilter.findIndex((item) => item.code === code);
        if (index > -1) {
          arr.push(airPortFilter[index]);
          airPortFilter.splice(index, 1);
        }
      });

      arr.push(...airPortFilter);

      return arr;
    }
    return [];
  }, [airportsDom, searchTerm]);

  const filterAirportsFor = useMemo(() => {
    if (airportsFor.length) {
      const globalFilter = airportsFor.filter((item) =>
        removeDiacritics(
          `${item.name_vi} ${item?.city_name_vi} ${item.city_code} ${item.country_name_en}`
        )
          .toLowerCase()
          .includes(removeDiacritics(searchTerm).toLowerCase())
      );

      const classifiedByCountry = globalFilter.reduce((acc, item) => {
        const { continent_code } = item;
        if (!acc[continent_code]) {
          acc[continent_code] = [];
        }
        if (acc[continent_code].length < 30) {
          acc[continent_code].push(item);
        }
        return acc;
      }, {});

      return listAirPortGlobal.map((item) => classifiedByCountry[item]);
    }

    return [];
  }, [airportsFor, searchTerm]);

  const onFinish = async (values) => {
    const startDate = new Date(values.DepartDate);
    const returnDate = new Date(values.ReturnDate);
    setAirport([values.StartPoint, values.EndPoint]);
    setFilterDay(dateFilterAir(startDate));
    values.ReturnDate && setFilterDayReturn(dateFilterAir(returnDate));
    onChangeStep(2);
  };

  useEffect(() => {
    setAirportsDom(
      airports.filter(
        (item) => item.country_code === "VN" && item.code !== "VCL"
      )
    );

    setAirportsFor(airports.filter((item) => item.country_code !== "VN"));
  }, [airports]);

  const handleSwap = () => {
    form.setFieldsValue({
      StartPoint: form.getFieldValue("EndPoint"),
      EndPoint: form.getFieldValue("StartPoint"),
    });
  };
  const [departureDate, setDepartureDate] = useState(dayjs());
  const handleValuesFormChange = (changedValues, allValues) => {
    const DepartDate = allValues.DepartDate;
    const ReturnDate = allValues.ReturnDate;
    if (DepartDate && DepartDate.isBefore(dayjs(), "day")) {
      message.error("Ngày đi phải lớn hơn hoặc bằng ngày hiện tại!");
      form.setFieldsValue({ DepartDate: null });
      setDepartureDate(null);
    }
    if (ReturnDate && DepartDate && ReturnDate.isBefore(DepartDate, "day")) {
      message.error("Ngày về phải lớn hơn hoặc bằng ngày đi!");
      form.setFieldsValue({ ReturnDate: null });
    }
    if (allValues.DepartDate) {
      setDepartureDate(allValues.DepartDate);
    }
  };

  const getDiscount = async () => {
    const values = form.getFieldsValue();
    try {
      const response = await $axios.$post(`/flights/searchmonth`, {
        StartPoint: values.StartPoint,
        EndPoint: values.EndPoint,
        Airline: "",
        Month: dayjs().get("month") + 1,
        Year: dayjs().get("year"),
      });
      setcheapFlights(response.data.data.ListMinPrice || []);
    } catch (error) {
      return null;
    }
  };
  useEffect(() => {
    if (StartPoint !== EndPoint) {
      getDiscount();
    }
  }, [StartPoint, EndPoint]);

  const handleSelectCheapFlight = (flight) => {
    setTripType("oneWay");
    setAirport([
      form.getFieldValue("StartPoint"),
      form.getFieldValue("EndPoint"),
    ]);
    setFilterDay(dateFilterAir(flight.ListFlight[0].StartDate));
    onChangeStep(2);
  };

  const onOpenChange = (type) => {
    setValueCalendar(form.getFieldValue(type) ?? new Date());
    setOpenCalendar(true);
    setTypeCalendar(type);
    if (type === "ReturnDate") {
      setMinDateCalendar(new Date(form.getFieldValue("DepartDate")));
    } else {
      setMinDateCalendar(new Date());
    }
  };

  const setValue = (value) => {
    form.setFieldValue(typeCalendar, dayjs(value));
    setValueCalendar(value);
    if (
      typeCalendar === "DepartDate" &&
      dayjs(value) > form.getFieldValue("ReturnDate")
    ) {
      const newReturnDate = dayjs(value).add(3, "day");
      form.setFieldValue("ReturnDate", newReturnDate);
    }
    setOpenCalendar(false);
  };

  return (
    <div className="min-h-screen flex flex-col items-center step1  overflow-scroll">
      <CalendarCustom
        openCalendar={openCalendar}
        setOpenCalendar={setOpenCalendar}
        typeCalendar={typeCalendar}
        form={form}
        valueCalendar={valueCalendar}
        setValue={setValue}
        minDate={minDateCalendar}
      />
      <>
        <div className="w-full 0 shadow-lg">
          <img src={BgForm} alt="" className="w-full object-cover mx-auto" />
          <div className="w-[90%] mx-auto absolute top-[30px] left-1/2 transform -translate-x-1/2 flex flex-col">
            <div className="flex justify-between items-center">
              <div className="w-[32px]"></div>
              <div
                className="flex gap-2 items-center cursor-pointer"
                onClick={() => onChangeStep(0)}
              >
                <img
                  className="w-[32px] p-1 h-[32px] bg-white rounded-full"
                  src={"/images/history.svg"}
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="w-[90%] mx-auto absolute top-[15%] left-1/2 transform -translate-x-1/2 -translate-y-4/5 pb-[40px] flex flex-col ">
            <Form
              form={form}
              onFinish={onFinish}
              layout="vertical"
              onValuesChange={handleValuesFormChange}
              onFinishFailed={(values) => {}}
              initialValues={{
                StartPoint: "HAN",
                EndPoint: "SGN",
                DepartDate: dayjs(),
              }}
              className="form-search"
            >
              <div
                style={{
                  boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                }}
                className="rounded-2xl bg-accent"
              >
                <div
                  style={{
                    boxShadow: "0px 2px 2px 0px rgba(0, 0, 0, 0.25)",
                  }}
                  className=" bg-white p-4 rounded-2xl"
                >
                  <Row
                    gutter={16}
                    className="items-center"
                    justify={"space-between"}
                  >
                    <Col
                      span={10}
                      style={{
                        paddingRight: 0,
                      }}
                    >
                      {/* Điểm đi */}
                      <Form.Item label="Điểm đi" name={"StartPoint"}>
                        <Select
                          className="w-full"
                          suffixIcon={
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="text-primary"
                            >
                              <g clip-path="url(#clip0_1_310)">
                                <mask
                                  id="mask0_1_310"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="20"
                                  height="20"
                                >
                                  <path d="M20 0H0V20H20V0Z" fill="white" />
                                </mask>
                                <g mask="url(#mask0_1_310)">
                                  <path
                                    d="M19.2187 18.5547H0.781366C0.349885 18.5547 0.00012207 18.2049 0.00012207 17.7734C0.00012207 17.3419 0.349885 16.9922 0.781366 16.9922H19.2187C19.6502 16.9922 20 17.3419 20 17.7734C20 18.2049 19.6502 18.5547 19.2187 18.5547Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M4.72986 14.6515C4.37478 14.6515 4.01752 14.6048 3.66537 14.5102C2.61355 14.2276 1.73473 13.5523 1.19078 12.6087L0.106106 10.7445C-0.110884 10.3715 0.0155604 9.89331 0.388487 9.67632C0.761413 9.45937 1.23965 9.58574 1.45664 9.9587L2.54288 11.8257C2.87995 12.4104 3.42198 12.8269 4.07076 13.0011C4.71943 13.1755 5.39727 13.0866 5.97926 12.7511L18.301 5.64834C18.4172 5.58135 18.4349 5.45909 18.4371 5.40963C18.4397 5.35077 18.4293 5.24155 18.3295 5.17139C17.5555 4.6273 16.7606 4.58277 15.9669 5.0389L13.1126 6.72716C12.8403 6.88826 12.4977 6.86927 12.245 6.67888L8.28268 3.69574C7.64604 3.26207 7.10206 3.03086 6.66566 3.00852C6.4489 2.99711 6.34125 3.1345 6.30488 3.19387C6.26676 3.2561 6.21684 3.37742 6.28117 3.52324L8.83631 6.68591C8.86197 6.71767 8.8851 6.75134 8.90545 6.78669C9.16716 7.24071 9.23642 7.7695 9.10045 8.27559C8.9649 8.78012 8.64162 9.20191 8.18983 9.46382L4.88986 11.4147C4.51837 11.6343 4.03935 11.5112 3.81975 11.1397C3.60014 10.7683 3.72326 10.2892 4.09467 10.0696L7.39776 8.11692C7.40023 8.11547 7.40269 8.11403 7.40519 8.11262C7.49765 8.05934 7.56378 7.97325 7.59147 7.8702C7.61518 7.78184 7.60823 7.69016 7.57222 7.60751L5.01751 4.44538C4.99185 4.41363 4.96876 4.37996 4.94837 4.34464C4.58994 3.72289 4.59896 2.98762 4.97247 2.37778C5.34634 1.76736 6.02535 1.41103 6.7457 1.44806C7.48718 1.48607 8.28326 1.80267 9.17939 2.41599C9.18912 2.42263 9.19865 2.4295 9.20802 2.43657L12.7671 5.11612L15.1756 3.69156C15.1781 3.69008 15.1805 3.68859 15.1831 3.68715C16.5124 2.92086 17.949 2.99387 19.2281 3.89305C19.7387 4.25195 20.0265 4.84507 19.998 5.47963C19.9694 6.11854 19.6267 6.68763 19.0813 7.00197L6.75964 14.1048C6.13199 14.4667 5.43544 14.6515 4.72986 14.6515Z"
                                    fill="currentColor"
                                  />
                                </g>
                              </g>
                              <defs>
                                <clipPath id="clip0_1_310">
                                  <rect width="20" height="20" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          }
                          showSearch={false} // Ẩn menu Select mặc định
                          open={false} // Ẩn menu mặc định của Select
                          onClick={() => {
                            setOpenDrawer(true);
                            setNameField("StartPoint");
                          }} // Mở drawer khi nhấn vào Select
                          options={[
                            {
                              label: <span>Nội địa</span>,
                              title: "Nội địa",
                              options: airportsDom.map((item) => ({
                                label: (
                                  <span className="flex flex-col">
                                    <span className="leading-4 text-[14px] font-medium">
                                      {" "}
                                      {item?.city_name_vi}
                                    </span>
                                    <span className="leading-4 text-[14px] font-medium">
                                      {item.city_code}
                                    </span>
                                  </span>
                                ),
                                title: `${item.name_vi} ${item?.city_name_vi} ${item.city_code}`, // Thêm thuộc tính title cho filter
                                value: item.code,
                              })),
                            },
                            {
                              label: <span>Quốc tế</span>,
                              title: "Quốc tế",
                              options: airportsFor.map((item) => ({
                                label: (
                                  <span className="flex flex-col">
                                    <span className="leading-4 text-[14px] font-medium">
                                      {" "}
                                      {item?.city_name_vi}
                                    </span>
                                    <span className="leading-4 text-[14px] font-medium">
                                      {item.city_code}
                                    </span>
                                  </span>
                                ),
                                title: `${item.name_vi} ${item?.city_name_vi} ${item.city_code}`, // Thêm thuộc tính title cho filter
                                value: item.code,
                              })),
                            },
                          ]}
                        />
                      </Form.Item>
                      {!loadingAirPorts && (
                        <div className="location">
                          <Drawer
                            title={
                              <h1 className="text-lg font-bold">
                                Chọn điểm{" "}
                                {nameField === "StartPoint" ? "đi" : "đến"}
                              </h1>
                            }
                            placement="bottom"
                            open={openDrawer}
                            onClose={() => setOpenDrawer(false)}
                            height="100vh"
                          >
                            <div className="p-4">
                              <Input
                                placeholder="Tìm kiếm sân bay"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="mb-4"
                              />

                              <div className="airport-list overflow-auto">
                                {!!filterAirports.length && (
                                  <>
                                    <h4 className="mb-2 text-md font-semibold text-primary">
                                      Việt Nam
                                    </h4>
                                    <div className="flex gap-2.5 flex-wrap">
                                      {filterAirports.map((item) => (
                                        <div
                                          className="h-8 flex items-center rounded-lg px-2 bg-[#EDF2F7]"
                                          onClick={() =>
                                            handleSelect(item.code)
                                          }
                                        >
                                          {item?.name_vi.replace(
                                            "Sân bay ",
                                            ""
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  </>
                                )}

                                {filterAirportsFor.map((item) => (
                                  <div>
                                    <h4 className="my-2 text-md font-semibold text-primary">
                                      {item?.[0]?.continent_name_vi}
                                    </h4>
                                    <div className="flex gap-2 flex-wrap">
                                      {item?.map((airport) => (
                                        <div
                                          className="h-8 flex items-center rounded-lg px-2 bg-[#EDF2F7]"
                                          onClick={() =>
                                            handleSelect(airport.code)
                                          }
                                        >
                                          {airport?.name_vi.replace(
                                            "Sân bay ",
                                            ""
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </Drawer>
                        </div>
                      )}
                    </Col>
                    <Col span={4} className="flex items-center justify-center">
                      <svg
                        width="25"
                        height="26"
                        viewBox="0 0 25 26"
                        className="cursor-pointer text-primary"
                        onClick={() => handleSwap()}
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_1_319)">
                          <g clip-path="url(#clip1_1_319)">
                            <path
                              d="M23.7123 12.9585C23.7117 6.60721 18.5624 1.45904 12.2111 1.45971C5.85984 1.46039 0.711661 6.60966 0.712338 12.9609C0.713014 19.3122 5.86229 24.4604 12.2136 24.4597C18.5648 24.459 23.713 19.3098 23.7123 12.9585Z"
                              fill="currentColor"
                              stroke="#F5F6F6"
                            />
                            <path
                              d="M9.94135 12.4163C9.68931 12.6683 9.28063 12.6684 9.02857 12.4163L6.30109 9.68948C6.04901 9.43745 6.04895 9.02876 6.301 8.7767L9.94135 12.4163ZM9.94135 12.4163C10.1934 12.1642 10.1933 11.7555 9.94126 11.5035L8.3157 9.8783L17.6663 9.87731C18.0227 9.87727 18.3117 9.58826 18.3116 9.2318C18.3116 8.87535 18.0226 8.5864 17.6661 8.58644L8.31556 8.58743L9.94073 6.96188C10.1928 6.70982 10.1927 6.30113 9.94064 6.04909C9.81465 5.92313 9.64929 5.86009 9.48425 5.86011C9.31922 5.86013 9.15386 5.9232 9.0279 6.04923L6.301 8.7767L9.94135 12.4163Z"
                              fill="white"
                            />
                            <path
                              d="M14.4819 14.1891C14.7339 13.9371 15.1426 13.937 15.3946 14.1891L18.1221 16.916C18.3742 17.168 18.3743 17.5767 18.1222 17.8288L14.4819 14.1891ZM14.4819 14.1891C14.2298 14.4412 14.2299 14.8499 14.482 15.1019L16.1075 16.7272L6.75693 16.7282C6.40053 16.7282 6.11153 17.0172 6.11163 17.3737C6.11163 17.7301 6.40063 18.0191 6.75713 18.019L16.1077 18.018L14.4825 19.6436C14.2304 19.8957 14.2305 20.3043 14.4826 20.5564C14.6086 20.6823 14.7739 20.7454 14.939 20.7454C15.104 20.7453 15.2694 20.6823 15.3953 20.5562L18.1222 17.8288L14.4819 14.1891Z"
                              fill="white"
                            />
                          </g>
                        </g>
                        <defs>
                          <clipPath id="clip0_1_319">
                            <rect
                              width="24"
                              height="25"
                              fill="white"
                              transform="translate(0.212585 0.5)"
                            />
                          </clipPath>
                          <clipPath id="clip1_1_319">
                            <rect
                              width="24"
                              height="25"
                              fill="white"
                              transform="translate(0.212585 0.5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </Col>
                    <Col
                      span={10}
                      style={{
                        paddingLeft: 0,
                      }}
                      className="pl-0"
                    >
                      {/* Điểm đến */}
                      <Form.Item
                        className="form-item-right-label"
                        label="Điểm đến"
                        name={"EndPoint"}
                      >
                        <Select
                          className="w-full h-16"
                          suffixIcon={
                            <svg
                              width="21"
                              height="20"
                              viewBox="0 0 21 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="text-primary"
                            >
                              <g clip-path="url(#clip0_1_327)">
                                <mask
                                  id="mask0_1_327"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="21"
                                  height="20"
                                >
                                  <path
                                    d="M20.2126 0H0.212585V20H20.2126V0Z"
                                    fill="white"
                                  />
                                </mask>
                                <g mask="url(#mask0_1_327)">
                                  <path
                                    d="M17.574 14.98C17.3563 14.98 17.1378 14.941 16.9279 14.8615L3.66684 9.82426C2.64907 9.43887 1.84164 8.67965 1.39414 7.68668C0.946684 6.69375 0.91266 5.58598 1.29836 4.56742C1.2991 4.56547 1.29985 4.56348 1.30063 4.56153L2.08121 2.54946C2.23727 2.14723 2.68981 1.94766 3.09215 2.10367C3.49442 2.25973 3.69399 2.71235 3.53793 3.11461L2.75852 5.1236C2.52172 5.75106 2.54305 6.43317 2.81867 7.04473C3.09465 7.65715 3.59266 8.12547 4.22086 8.36332L17.482 13.4006C17.6066 13.4478 17.7124 13.3841 17.7522 13.3545C17.7994 13.3192 17.8773 13.242 17.8684 13.1203C17.7992 12.1764 17.3301 11.533 16.4739 11.2077L13.3804 10.0678C13.0841 9.9586 12.8827 9.68184 12.8699 9.36633L12.669 4.41067C12.6013 3.64332 12.4357 3.07594 12.1766 2.72403C12.0482 2.54957 11.8737 2.55278 11.8047 2.56227C11.7324 2.57219 11.6069 2.61039 11.5348 2.75254C11.5348 2.75254 10.6858 6.81215 10.6713 6.85032C10.3745 7.63399 9.6266 8.11746 8.83438 8.11754C8.60383 8.11754 8.36973 8.07664 8.14168 7.99028L4.54219 6.60828C4.13938 6.45364 3.93824 6.00172 4.09289 5.59891C4.24754 5.19614 4.69957 4.99496 5.10223 5.14961L8.6984 6.53035C8.88684 6.60176 9.10016 6.51657 9.19172 6.33836C9.19172 6.33836 10.0405 2.27949 10.055 2.24133C10.3092 1.5702 10.8839 1.11149 11.5924 1.0143C12.3016 0.916995 13.0076 1.21723 13.4349 1.7977C13.8751 2.39567 14.1343 3.21223 14.2272 4.29418C14.2282 4.3059 14.41 8.78203 14.41 8.78203L17.0176 9.74297C17.0198 9.74379 17.022 9.74457 17.0242 9.74543C18.4591 10.2888 19.3124 11.4468 19.4267 13.0061C19.4723 13.6286 19.1956 14.227 18.6865 14.6069C18.3568 14.8529 17.9669 14.98 17.574 14.98Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M19.4314 19.0039H0.993835C0.562351 19.0039 0.212585 18.6541 0.212585 18.2227C0.212585 17.7912 0.562351 17.4414 0.993835 17.4414H19.4314C19.8628 17.4414 20.2126 17.7912 20.2126 18.2227C20.2126 18.6541 19.8628 19.0039 19.4314 19.0039Z"
                                    fill="currentColor"
                                  />
                                </g>
                              </g>
                              <defs>
                                <clipPath id="clip0_1_327">
                                  <rect
                                    width="20"
                                    height="20"
                                    fill="white"
                                    transform="translate(0.212585)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          }
                          showSearch={false} // Ẩn menu Select mặc định
                          open={false} // Ẩn menu mặc định của Select
                          onClick={() => {
                            setOpenDrawer(true);
                            setNameField("EndPoint");
                          }} // Mở drawer khi nhấn vào Select
                          options={[
                            {
                              label: <span>Nội địa</span>,
                              title: "Nội địa",
                              options: airportsDom.map((item) => ({
                                label: (
                                  <span className="flex flex-col">
                                    <span className="leading-4 text-[12px] font-medium">
                                      {" "}
                                      {item?.city_name_vi}
                                    </span>
                                    <span className="leading-4 text-[12px] font-medium">
                                      {item.city_code}
                                    </span>
                                  </span>
                                ),
                                title: `${item.name_vi} ${item?.city_name_vi} ${item.city_code}`, // Thêm thuộc tính title cho filter
                                value: item.code,
                              })),
                            },
                            {
                              label: <span>Quốc tế</span>,
                              title: "Quốc tế",
                              options: airportsFor.map((item) => ({
                                label: (
                                  <span className="flex flex-col">
                                    <span className="leading-4 text-[12px] font-medium">
                                      {" "}
                                      {item?.city_name_vi}
                                    </span>
                                    <span className="leading-4 text-[12px] font-medium">
                                      {item.city_code}
                                    </span>
                                  </span>
                                ),
                                title: `${item.name_vi} ${item?.city_name_vi} ${item.city_code}`, // Thêm thuộc tính title cho filter
                                value: item.code,
                              })),
                            },
                          ]}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  {/* Ngày đi */}
                  <div className="flex items-center justify-between w-full mb-2">
                    <label className="font-medium text-secondary">
                      Ngày đi
                    </label>
                    <div className="flex items-center gap-2">
                      <Switch
                        checked={tripType === "roundTrip"}
                        onChange={(checked) => {
                          setTripType(checked ? "roundTrip" : "oneWay");
                        }}
                      />{" "}
                      <label className="font-medium text-secondary">
                        Khứ hồi
                      </label>
                    </div>
                  </div>
                  {tripType === "oneWay" ? (
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Vui lòng chọn ngày!",
                        },
                      ]}
                      name={"DepartDate"}
                    >
                      <DatePicker
                        open={false}
                        className="w-full"
                        placeholder="Chọn ngày"
                        format="DD/MM/YYYY"
                        minDate={dayjs()}
                        locale={locale} // Thiết lập locale tiếng Việt
                        suffixIcon={
                          <svg
                            className="text-primary"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_120_8739)">
                              <path
                                d="M10.8984 14.2188C10.8984 15.0803 11.5994 15.7812 12.4609 15.7812H14.2969C15.1584 15.7812 15.8594 15.0803 15.8594 14.2188V12.3828C15.8594 11.5213 15.1584 10.8203 14.2969 10.8203H12.4609C11.5994 10.8203 10.8984 11.5213 10.8984 12.3828V14.2188ZM12.4609 12.3828H14.2969L14.2979 14.2187C14.2979 14.2187 14.2976 14.2188 14.2969 14.2188H12.4609V12.3828Z"
                                fill="currentColor"
                              />
                              <path
                                d="M15.0781 8.98438C15.5096 8.98438 15.8594 8.6346 15.8594 8.20312C15.8594 7.77165 15.5096 7.42188 15.0781 7.42188C14.6467 7.42188 14.2969 7.77165 14.2969 8.20312C14.2969 8.6346 14.6467 8.98438 15.0781 8.98438Z"
                                fill="currentColor"
                              />
                              <path
                                d="M11.6797 8.98438C12.1112 8.98438 12.4609 8.6346 12.4609 8.20312C12.4609 7.77165 12.1112 7.42188 11.6797 7.42188C11.2482 7.42188 10.8984 7.77165 10.8984 8.20312C10.8984 8.6346 11.2482 8.98438 11.6797 8.98438Z"
                                fill="currentColor"
                              />
                              <path
                                d="M19.2188 13.75C19.6502 13.75 20 13.4002 20 12.9688V4.6875C20 2.96438 18.5981 1.5625 16.875 1.5625H15.8594V0.78125C15.8594 0.349766 15.5096 0 15.0781 0C14.6466 0 14.2969 0.349766 14.2969 0.78125V1.5625H10.7422V0.78125C10.7422 0.349766 10.3924 0 9.96094 0C9.52945 0 9.17969 0.349766 9.17969 0.78125V1.5625H5.66406V0.78125C5.66406 0.349766 5.3143 0 4.88281 0C4.45133 0 4.10156 0.349766 4.10156 0.78125V1.5625H3.125C1.40188 1.5625 0 2.96438 0 4.6875V16.875C0 18.5981 1.40188 20 3.125 20H16.875C18.5981 20 20 18.5981 20 16.875C20 16.4435 19.6502 16.0938 19.2188 16.0938C18.7873 16.0938 18.4375 16.4435 18.4375 16.875C18.4375 17.7366 17.7366 18.4375 16.875 18.4375H3.125C2.26344 18.4375 1.5625 17.7366 1.5625 16.875V4.6875C1.5625 3.82594 2.26344 3.125 3.125 3.125H4.10156V3.90625C4.10156 4.33773 4.45133 4.6875 4.88281 4.6875C5.3143 4.6875 5.66406 4.33773 5.66406 3.90625V3.125H9.17969V3.90625C9.17969 4.33773 9.52945 4.6875 9.96094 4.6875C10.3924 4.6875 10.7422 4.33773 10.7422 3.90625V3.125H14.2969V3.90625C14.2969 4.33773 14.6466 4.6875 15.0781 4.6875C15.5096 4.6875 15.8594 4.33773 15.8594 3.90625V3.125H16.875C17.7366 3.125 18.4375 3.82594 18.4375 4.6875V12.9688C18.4375 13.4002 18.7873 13.75 19.2188 13.75Z"
                                fill="currentColor"
                              />
                              <path
                                d="M4.88281 15.7812C5.31428 15.7812 5.66406 15.4315 5.66406 15C5.66406 14.5685 5.31428 14.2188 4.88281 14.2188C4.45134 14.2188 4.10156 14.5685 4.10156 15C4.10156 15.4315 4.45134 15.7812 4.88281 15.7812Z"
                                fill="currentColor"
                              />
                              <path
                                d="M4.88281 8.98438C5.31428 8.98438 5.66406 8.6346 5.66406 8.20312C5.66406 7.77165 5.31428 7.42188 4.88281 7.42188C4.45134 7.42188 4.10156 7.77165 4.10156 8.20312C4.10156 8.6346 4.45134 8.98438 4.88281 8.98438Z"
                                fill="currentColor"
                              />
                              <path
                                d="M4.88281 12.3828C5.31428 12.3828 5.66406 12.033 5.66406 11.6016C5.66406 11.1701 5.31428 10.8203 4.88281 10.8203C4.45134 10.8203 4.10156 11.1701 4.10156 11.6016C4.10156 12.033 4.45134 12.3828 4.88281 12.3828Z"
                                fill="currentColor"
                              />
                              <path
                                d="M8.28125 12.3828C8.71272 12.3828 9.0625 12.033 9.0625 11.6016C9.0625 11.1701 8.71272 10.8203 8.28125 10.8203C7.84978 10.8203 7.5 11.1701 7.5 11.6016C7.5 12.033 7.84978 12.3828 8.28125 12.3828Z"
                                fill="currentColor"
                              />
                              <path
                                d="M8.28125 8.98438C8.71272 8.98438 9.0625 8.6346 9.0625 8.20312C9.0625 7.77165 8.71272 7.42188 8.28125 7.42188C7.84978 7.42188 7.5 7.77165 7.5 8.20312C7.5 8.6346 7.84978 8.98438 8.28125 8.98438Z"
                                fill="currentColor"
                              />
                              <path
                                d="M8.28125 15.7812C8.71272 15.7812 9.0625 15.4315 9.0625 15C9.0625 14.5685 8.71272 14.2188 8.28125 14.2188C7.84978 14.2188 7.5 14.5685 7.5 15C7.5 15.4315 7.84978 15.7812 8.28125 15.7812Z"
                                fill="currentColor"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_120_8739">
                                <rect width="20" height="20" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        }
                        allowClear={false}
                        inputReadOnly
                        onOpenChange={() => onOpenChange("DepartDate")}
                      />
                    </Form.Item>
                  ) : (
                    <Row gutter={12}>
                      <Col span={12}>
                        <Form.Item
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng chọn ngày!",
                            },
                          ]}
                          name={"DepartDate"}
                        >
                          <DatePicker
                            open={false}
                            minDate={dayjs()}
                            style={{ width: "100%" }}
                            placeholder="Chọn ngày"
                            locale={locale} // Thiết lập locale tiếng Việt
                            format="DD/MM/YYYY"
                            suffixIcon={
                              <svg
                                className="text-primary"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_120_8739)">
                                  <path
                                    d="M10.8984 14.2188C10.8984 15.0803 11.5994 15.7812 12.4609 15.7812H14.2969C15.1584 15.7812 15.8594 15.0803 15.8594 14.2188V12.3828C15.8594 11.5213 15.1584 10.8203 14.2969 10.8203H12.4609C11.5994 10.8203 10.8984 11.5213 10.8984 12.3828V14.2188ZM12.4609 12.3828H14.2969L14.2979 14.2187C14.2979 14.2187 14.2976 14.2188 14.2969 14.2188H12.4609V12.3828Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M15.0781 8.98438C15.5096 8.98438 15.8594 8.6346 15.8594 8.20312C15.8594 7.77165 15.5096 7.42188 15.0781 7.42188C14.6467 7.42188 14.2969 7.77165 14.2969 8.20312C14.2969 8.6346 14.6467 8.98438 15.0781 8.98438Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M11.6797 8.98438C12.1112 8.98438 12.4609 8.6346 12.4609 8.20312C12.4609 7.77165 12.1112 7.42188 11.6797 7.42188C11.2482 7.42188 10.8984 7.77165 10.8984 8.20312C10.8984 8.6346 11.2482 8.98438 11.6797 8.98438Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M19.2188 13.75C19.6502 13.75 20 13.4002 20 12.9688V4.6875C20 2.96438 18.5981 1.5625 16.875 1.5625H15.8594V0.78125C15.8594 0.349766 15.5096 0 15.0781 0C14.6466 0 14.2969 0.349766 14.2969 0.78125V1.5625H10.7422V0.78125C10.7422 0.349766 10.3924 0 9.96094 0C9.52945 0 9.17969 0.349766 9.17969 0.78125V1.5625H5.66406V0.78125C5.66406 0.349766 5.3143 0 4.88281 0C4.45133 0 4.10156 0.349766 4.10156 0.78125V1.5625H3.125C1.40188 1.5625 0 2.96438 0 4.6875V16.875C0 18.5981 1.40188 20 3.125 20H16.875C18.5981 20 20 18.5981 20 16.875C20 16.4435 19.6502 16.0938 19.2188 16.0938C18.7873 16.0938 18.4375 16.4435 18.4375 16.875C18.4375 17.7366 17.7366 18.4375 16.875 18.4375H3.125C2.26344 18.4375 1.5625 17.7366 1.5625 16.875V4.6875C1.5625 3.82594 2.26344 3.125 3.125 3.125H4.10156V3.90625C4.10156 4.33773 4.45133 4.6875 4.88281 4.6875C5.3143 4.6875 5.66406 4.33773 5.66406 3.90625V3.125H9.17969V3.90625C9.17969 4.33773 9.52945 4.6875 9.96094 4.6875C10.3924 4.6875 10.7422 4.33773 10.7422 3.90625V3.125H14.2969V3.90625C14.2969 4.33773 14.6466 4.6875 15.0781 4.6875C15.5096 4.6875 15.8594 4.33773 15.8594 3.90625V3.125H16.875C17.7366 3.125 18.4375 3.82594 18.4375 4.6875V12.9688C18.4375 13.4002 18.7873 13.75 19.2188 13.75Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M4.88281 15.7812C5.31428 15.7812 5.66406 15.4315 5.66406 15C5.66406 14.5685 5.31428 14.2188 4.88281 14.2188C4.45134 14.2188 4.10156 14.5685 4.10156 15C4.10156 15.4315 4.45134 15.7812 4.88281 15.7812Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M4.88281 8.98438C5.31428 8.98438 5.66406 8.6346 5.66406 8.20312C5.66406 7.77165 5.31428 7.42188 4.88281 7.42188C4.45134 7.42188 4.10156 7.77165 4.10156 8.20312C4.10156 8.6346 4.45134 8.98438 4.88281 8.98438Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M4.88281 12.3828C5.31428 12.3828 5.66406 12.033 5.66406 11.6016C5.66406 11.1701 5.31428 10.8203 4.88281 10.8203C4.45134 10.8203 4.10156 11.1701 4.10156 11.6016C4.10156 12.033 4.45134 12.3828 4.88281 12.3828Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M8.28125 12.3828C8.71272 12.3828 9.0625 12.033 9.0625 11.6016C9.0625 11.1701 8.71272 10.8203 8.28125 10.8203C7.84978 10.8203 7.5 11.1701 7.5 11.6016C7.5 12.033 7.84978 12.3828 8.28125 12.3828Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M8.28125 8.98438C8.71272 8.98438 9.0625 8.6346 9.0625 8.20312C9.0625 7.77165 8.71272 7.42188 8.28125 7.42188C7.84978 7.42188 7.5 7.77165 7.5 8.20312C7.5 8.6346 7.84978 8.98438 8.28125 8.98438Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M8.28125 15.7812C8.71272 15.7812 9.0625 15.4315 9.0625 15C9.0625 14.5685 8.71272 14.2188 8.28125 14.2188C7.84978 14.2188 7.5 14.5685 7.5 15C7.5 15.4315 7.84978 15.7812 8.28125 15.7812Z"
                                    fill="currentColor"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_120_8739">
                                    <rect width="20" height="20" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            }
                            allowClear={false}
                            inputReadOnly
                            onOpenChange={() => onOpenChange("DepartDate")}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng chọn ngày!",
                            },
                          ]}
                          name={"ReturnDate"}
                        >
                          <DatePicker
                            open={false}
                            minDate={dayjs(departureDate)}
                            style={{ width: "100%" }}
                            placeholder="Chọn ngày"
                            locale={locale} // Thiết lập locale tiếng Việt
                            format="DD/MM/YYYY"
                            suffixIcon={
                              <svg
                                className="text-primary"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_120_8739)">
                                  <path
                                    d="M10.8984 14.2188C10.8984 15.0803 11.5994 15.7812 12.4609 15.7812H14.2969C15.1584 15.7812 15.8594 15.0803 15.8594 14.2188V12.3828C15.8594 11.5213 15.1584 10.8203 14.2969 10.8203H12.4609C11.5994 10.8203 10.8984 11.5213 10.8984 12.3828V14.2188ZM12.4609 12.3828H14.2969L14.2979 14.2187C14.2979 14.2187 14.2976 14.2188 14.2969 14.2188H12.4609V12.3828Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M15.0781 8.98438C15.5096 8.98438 15.8594 8.6346 15.8594 8.20312C15.8594 7.77165 15.5096 7.42188 15.0781 7.42188C14.6467 7.42188 14.2969 7.77165 14.2969 8.20312C14.2969 8.6346 14.6467 8.98438 15.0781 8.98438Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M11.6797 8.98438C12.1112 8.98438 12.4609 8.6346 12.4609 8.20312C12.4609 7.77165 12.1112 7.42188 11.6797 7.42188C11.2482 7.42188 10.8984 7.77165 10.8984 8.20312C10.8984 8.6346 11.2482 8.98438 11.6797 8.98438Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M19.2188 13.75C19.6502 13.75 20 13.4002 20 12.9688V4.6875C20 2.96438 18.5981 1.5625 16.875 1.5625H15.8594V0.78125C15.8594 0.349766 15.5096 0 15.0781 0C14.6466 0 14.2969 0.349766 14.2969 0.78125V1.5625H10.7422V0.78125C10.7422 0.349766 10.3924 0 9.96094 0C9.52945 0 9.17969 0.349766 9.17969 0.78125V1.5625H5.66406V0.78125C5.66406 0.349766 5.3143 0 4.88281 0C4.45133 0 4.10156 0.349766 4.10156 0.78125V1.5625H3.125C1.40188 1.5625 0 2.96438 0 4.6875V16.875C0 18.5981 1.40188 20 3.125 20H16.875C18.5981 20 20 18.5981 20 16.875C20 16.4435 19.6502 16.0938 19.2188 16.0938C18.7873 16.0938 18.4375 16.4435 18.4375 16.875C18.4375 17.7366 17.7366 18.4375 16.875 18.4375H3.125C2.26344 18.4375 1.5625 17.7366 1.5625 16.875V4.6875C1.5625 3.82594 2.26344 3.125 3.125 3.125H4.10156V3.90625C4.10156 4.33773 4.45133 4.6875 4.88281 4.6875C5.3143 4.6875 5.66406 4.33773 5.66406 3.90625V3.125H9.17969V3.90625C9.17969 4.33773 9.52945 4.6875 9.96094 4.6875C10.3924 4.6875 10.7422 4.33773 10.7422 3.90625V3.125H14.2969V3.90625C14.2969 4.33773 14.6466 4.6875 15.0781 4.6875C15.5096 4.6875 15.8594 4.33773 15.8594 3.90625V3.125H16.875C17.7366 3.125 18.4375 3.82594 18.4375 4.6875V12.9688C18.4375 13.4002 18.7873 13.75 19.2188 13.75Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M4.88281 15.7812C5.31428 15.7812 5.66406 15.4315 5.66406 15C5.66406 14.5685 5.31428 14.2188 4.88281 14.2188C4.45134 14.2188 4.10156 14.5685 4.10156 15C4.10156 15.4315 4.45134 15.7812 4.88281 15.7812Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M4.88281 8.98438C5.31428 8.98438 5.66406 8.6346 5.66406 8.20312C5.66406 7.77165 5.31428 7.42188 4.88281 7.42188C4.45134 7.42188 4.10156 7.77165 4.10156 8.20312C4.10156 8.6346 4.45134 8.98438 4.88281 8.98438Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M4.88281 12.3828C5.31428 12.3828 5.66406 12.033 5.66406 11.6016C5.66406 11.1701 5.31428 10.8203 4.88281 10.8203C4.45134 10.8203 4.10156 11.1701 4.10156 11.6016C4.10156 12.033 4.45134 12.3828 4.88281 12.3828Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M8.28125 12.3828C8.71272 12.3828 9.0625 12.033 9.0625 11.6016C9.0625 11.1701 8.71272 10.8203 8.28125 10.8203C7.84978 10.8203 7.5 11.1701 7.5 11.6016C7.5 12.033 7.84978 12.3828 8.28125 12.3828Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M8.28125 8.98438C8.71272 8.98438 9.0625 8.6346 9.0625 8.20312C9.0625 7.77165 8.71272 7.42188 8.28125 7.42188C7.84978 7.42188 7.5 7.77165 7.5 8.20312C7.5 8.6346 7.84978 8.98438 8.28125 8.98438Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M8.28125 15.7812C8.71272 15.7812 9.0625 15.4315 9.0625 15C9.0625 14.5685 8.71272 14.2188 8.28125 14.2188C7.84978 14.2188 7.5 14.5685 7.5 15C7.5 15.4315 7.84978 15.7812 8.28125 15.7812Z"
                                    fill="currentColor"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_120_8739">
                                    <rect width="20" height="20" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            }
                            allowClear={false}
                            inputReadOnly
                            onOpenChange={() => onOpenChange("ReturnDate")}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  )}
                  {/* Hành khách */}
                  <div className="flex justify-between items-center">
                    <div className="flex flex-col grow">
                      <div>
                        <CustomInputNumber
                          form={form}
                          name="Adt"
                          label={
                            <span className="mb-1 text-[14px] font-medium text-secondary flex items-center gap-2">
                              <img src="/images/aldult.svg" alt="" />
                              Người lớn
                            </span>
                          }
                          min={0}
                          max={9}
                          defaultValue={1}
                        />
                      </div>
                      <p className="mt-2 text-[14px] text-[#808080] text-center font-normal">
                        (12+ tuổi)
                      </p>
                    </div>
                    <div className="flex flex-col grow">
                      <div>
                        <CustomInputNumber
                          form={form}
                          name="Chd"
                          label={
                            <span className="mb-1 text-[14px] font-medium text-secondary flex items-center gap-2">
                              <img
                                className="mr-1"
                                src="/images/child.svg"
                                alt=""
                              />
                              Trẻ em
                            </span>
                          }
                          min={0}
                          max={9}
                          defaultValue={0}
                        />
                        <p className="mt-2 text-[14px] text-[#808080]  text-center font-normal">
                          (2-12 tuổi)
                        </p>
                      </div>
                    </div>
                    <div className="flex flex-col grow">
                      <div>
                        <CustomInputNumber
                          form={form}
                          name="Inf"
                          label={
                            <span className="mb-1 text-[14px] font-medium text-secondary flex items-center gap-2">
                              <img
                                src="/images/baby.svg"
                                className="mr-1"
                                alt=""
                              />
                              Em bé
                            </span>
                          }
                          min={0}
                          max={2}
                          defaultValue={0}
                        />

                        <p className="mt-2 text-[14px] text-[#808080] text-center font-normal">
                          (Dưới 2 tuổi)
                        </p>
                      </div>
                    </div>
                  </div>
                  <Form.Item className="mb-0">
                    <div className="text-center">
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="w-full rounded-lg mt-4 h-[48px] mx-auto"
                      >
                        <span className="text-[16px] font-semibold ">
                          Tìm chuyến bay
                        </span>
                      </Button>
                    </div>
                  </Form.Item>
                </div>
                <div className="py-5 px-4 rounded-ee-2xl rounded-es-2xl flex justify-between items-center">
                  <span className="font-semibold">
                    {" "}
                    Bạn đã có mã đơn hàng?{" "}
                  </span>
                  <Button
                    onClick={() => onChangeStep(0)}
                    variant="outlined"
                    className="bg-transparent rounded-lg w-[113px] h-[36px] border-[1px] border-solid border-primary text-primary"
                  >
                    <span className="text-[16px] font-semibold">
                      Tra cứu ngay
                    </span>
                  </Button>
                </div>
              </div>
            </Form>
            {/* Hotline */}
            <div className="text-center mt-4">
              <span className="text-[#808080] font-normal">
                Hotline hỗ trợ khách hàng{" "}
              </span>
              <a
                href="tel:1900255585"
                className="font-bold text-primary text-[16px]"
              >
                1900255585
              </a>
            </div>
            {/* Danh sách chuyến bay */}
            {(cheapFlights || []).length > 0 && (
              <div className="mb-8">
                <h1 className="font-bold text-[16px] text-primary my-6">
                  Vé siêu khuyến mại
                </h1>
                {(cheapFlights || []).slice(1, 8).map((airline, index) =>
                  (airline.ListFareData || [])
                    .slice(0, 1)
                    .map((item, flightIndex) => (
                      <div
                        key={flightIndex}
                        className="w-full px-3 py-4 bg-white rounded-[20px] mb-4"
                        style={{
                          boxShadow: "0px 4px 4px 4px rgba(0, 0, 0, 0.25)",
                        }}
                      >
                        <Row
                          gutter={8}
                          justify={"space-between"}
                          className="items-center"
                        >
                          <Col span={14}>
                            <Row gutter={4} align={"middle"}>
                              <Col span={8}>
                                <div className="flex flex-col items-center gap-1">
                                  <h4 className="font-bold text-[11px]">
                                    {item?.ListFlight?.[0]?.StartDt.split(
                                      " "
                                    )[1].split(":")[0] +
                                      ":" +
                                      item?.ListFlight?.[0]?.StartDt.split(
                                        " "
                                      )[1].split(":")[1]}
                                  </h4>
                                  <p className="text-[12px]">
                                    {item?.ListFlight?.[0].StartPoint}
                                  </p>
                                  <p className="text-[10px] text-[#808089]">
                                    {dayjs(
                                      item?.ListFlight?.[0].StartDate
                                    ).format("DD/MM/YYYY")}
                                  </p>
                                </div>
                              </Col>
                              <Col
                                span={8}
                                className="justify-center text-center"
                              >
                                <p className="text-[10px] text-[#808089]">
                                  {calculateTimeDifference(
                                    item?.ListFlight?.[0]?.StartDate,
                                    item?.ListFlight?.[
                                      item.ListFlight.length - 1
                                    ]?.EndDate
                                  )}
                                </p>
                                <img src="/images/flight-line.svg" alt="" />

                                <p className="text-[10px] text-[#808089]">
                                  {(item.ListFlight || []).length === 1
                                    ? "Bay thẳng"
                                    : `${
                                        (item.ListFlight || []).length - 1
                                      } điểm dừng`}
                                </p>
                              </Col>
                              <Col span={8}>
                                <div className="flex flex-col items-center gap-1">
                                  <h4 className="font-bold text-[12px]">
                                    {item?.ListFlight?.[
                                      item.ListFlight.length - 1
                                    ]?.EndDt.split(" ")[1].split(":")[0] +
                                      ":" +
                                      item?.ListFlight?.[
                                        item.ListFlight.length - 1
                                      ]?.EndDt.split(" ")[1].split(":")[1]}
                                  </h4>
                                  <p className="text-[11px] text-center">
                                    {
                                      item?.ListFlight?.[
                                        item.ListFlight.length - 1
                                      ].EndPoint
                                    }
                                  </p>
                                  <p className="text-[8px] text-[#808089]">
                                    {dayjs(
                                      item?.ListFlight?.[0].EndDate
                                    ).format("DD/MM/YYYY")}
                                  </p>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                          <Col span={10}>
                            <div className="flex gap-2 items-center mb-2">
                              <div className="font-bold text-primary text-[11px] ">
                                {formatNumberWithDots(item.TotalPrice)}{" "}
                                {item.Currency}
                              </div>
                              <Button
                                className="rounded-[16px] p-1 px-2 h-6 text-[10px]"
                                type="primary"
                                onClick={() => handleSelectCheapFlight(item)}
                              >
                                <p className="text-white text-[10px]">
                                  Chọn vé
                                </p>
                              </Button>
                            </div>

                            <div className="flex gap-2 items-center justify-between">
                              <p className="text-[10px] text-[#808089]">
                                /1 Hành khách
                              </p>
                              <p
                                className="text-primary text-[10px] flex gap items-center cursor-pointer"
                                onClick={() => {
                                  setDetailTicket(item);
                                  setDrawerVisible(true);
                                }}
                              >
                                Chi tiết
                                <svg
                                  width="8"
                                  height="8"
                                  viewBox="0 0 8 8"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="text-primary"
                                >
                                  <path
                                    d="M1 1L4.176 4L7.352 1"
                                    stroke="currentColor"
                                  />
                                  <path
                                    d="M1 4L4.176 7L7.352 4"
                                    stroke="currentColor"
                                  />
                                </svg>
                              </p>
                            </div>
                          </Col>
                        </Row>
                        <hr className="my-2" />
                        <Row className="justify-between items-center">
                          <div>
                            <div className="flex gap-2 items-center">
                              <img
                                className="w-auto h-4"
                                src={`https://abtrip.vn/images/airlines/${item.Airline.toLowerCase()}.gif`}
                                alt=""
                              />
                              <div className="flex flex-col gap-1">
                                <p className="text-[10px]">
                                  {item.Airline || ""}
                                </p>
                                <p className="text-[10px] text-primary">
                                  {item?.ListFlight?.[0]?.FlightNumber || ""}/{" "}
                                  {item?.ListFlight?.[0]?.GroupClass}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Row>
                        {dayjs(item?.ListFlight?.[0].StartDate).isSame(
                          dayjs(),
                          "day"
                        ) && (
                          <p className="text-red-500 text-[10px] mt-1">
                            Vé không thể giữ chỗ, cần thanh toán ngay
                          </p>
                        )}
                      </div>
                    ))
                )}
              </div>
            )}
          </div>
        </div>

        <TicketDetailsDrawer
          visible={drawerVisible}
          onClose={() => setDrawerVisible(false)}
          ticketDetails={detailTicket}
          airports={airports}
          handleSelectTicket={handleSelectCheapFlight}
        />
      </>
    </div>
  );
};

export default Step1;
